import { useNavigate } from 'react-router-dom'
import { ASSISTANT_SERVICES } from '../../AssistantPage/services'
import HomeBlock from './HomeBlock'
import './ToolsBlock.css'

/**
 * «Полезные инструменты» — то, что раньше жило отдельным разделом «Полезное».
 * Список тот же, что в хабе: фудпейринг и калькуляторы.
 *
 * Блок стоит и на главной, и в «Базе»: это вход в калькуляторы с обеих
 * страниц, по которым человек ходит чаще всего.
 */
const ToolsBlock = () => {
  const navigate = useNavigate()

  return (
    <HomeBlock title="Полезные инструменты">
      {ASSISTANT_SERVICES.map(service => (
        <button
          key={service.id}
          type="button"
          className="home-tool"
          style={{ background: service.color }}
          onClick={() => navigate(service.path)}
        >
          <img
            className="home-tool__icon"
            src={service.icon}
            alt=""
            style={{ width: service.iconWidth }}
          />
          {/* Колонка текста: в горизонтальной карточке название и описание
              стоят справа от иконки одним блоком. */}
          <span className="home-tool__body">
            <span className="home-tool__title">{service.title}</span>
            <span className="home-tool__text">{service.description}</span>
          </span>
        </button>
      ))}
    </HomeBlock>
  )
}

export default ToolsBlock
